import type { AgentState } from "@livekit/components-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
interface ConnectingNotificationProps extends React.PropsWithChildren<object> {
  state: AgentState;
}

/**
 * Renders some user info when no agent connects to the room after a certain time.
 */
export function ConnectingNotification(props: ConnectingNotificationProps) {
  const { t } = useTranslation();
  const [showNotification, setShowNotification] = useState(false);
  const agentHasConnected = useRef(false);

  // If the agent has connected, we don't need to show the notification.
  if (
    ["listening", "thinking", "speaking"].includes(props.state) &&
    agentHasConnected.current == false
  ) {
    agentHasConnected.current = true;
  }

  useEffect(() => {
    if (props.state === "connecting" && !agentHasConnected.current) {
      setShowNotification(true);
    } else {
      setShowNotification(false);
    }
  }, [props.state]);

  return (
    <>
      {showNotification ? (
        <div
          className="text-sm left-1/2 max-w-[90vw] flex top-6 items-center gap-4 px-4 py-3 rounded-lg bg-[#34a4d0] mb-4"
        >
          <p className="text-pretty w-max text-[#ffffff] font-medium">
            {t("connecting")}
          </p>
          <button onClick={() => setShowNotification(false)}>
            {/* Close Icon */}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.16602 3.16666L12.8327 12.8333M12.8327 3.16666L3.16602 12.8333"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinecap="square"
              />
            </svg>
          </button>
        </div>
      ) : null}
    </>
  );
}
